export function normalizeTagName(tag: string) {
	return tag.trim().replace(/\s+/g, ' ');
}

export function getUniqueTagNames(tags: string[] | null | undefined) {
	if (!tags?.length) {
		return [];
	}

	const map = new Map<string, string>();

	for (const t of tags) {
		const normalized = normalizeTagName(t);
		if (!normalized) {
			continue;
		}

		const key = normalized.toLowerCase();

		if (!map.has(key)) {
			map.set(key, normalized);
		}
	}

	return Array.from(map.values());
}
